import { type OrderIngredient } from '@hungryroot/orders';
import { type PairingV1 as Pairing } from '@hungryroot/rest';

interface Params {
  ingredientId: number;
  pairingIngredientIds: number[];
  swappablePairings: Pairing[];
}

interface SwappableIngredientsData {
  removablePairing: Pairing | null;
  ingredients: OrderIngredient[];
  pairings: Record<string, Pairing>;
}

export function getSwappableIngredients(
  params: Params
): SwappableIngredientsData {
  const { ingredientId, swappablePairings, pairingIngredientIds } = params;
  let removablePairing: Pairing | null = null;
  const pairingsByIngredient: Record<string, Pairing> = {};
  // Array of selectable ingredients
  const drawerIngredients: OrderIngredient[] = [];

  // rdpRecipeIngredients variable is an array of the targetPairing ingredients ids minus the selected one
  const rdpRecipeIngredients = pairingIngredientIds.filter(
    (targetPairingIngredientId) => targetPairingIngredientId !== ingredientId
  );

  swappablePairings.forEach((pairing) => {
    const { ingredients: pairingIngredients } = pairing;
    // from ingredient selected swappable recipes get the ingredients
    const selectableIngredientArray = pairingIngredients.filter(
      ({ id: pairingIngredientId }) => {
        return rdpRecipeIngredients.includes(pairingIngredientId) === false;
      }
    );

    const { length: selectableIngredientsLength } = selectableIngredientArray;

    // if there is more than 1 ingredient left don't consider the recipe:
    if (selectableIngredientsLength > 1) {
      return;
    }

    // a recipe exists with one less ingredient
    // setting up option for ingredient to be removed
    if (selectableIngredientsLength === 0) {
      removablePairing = pairing;
      return;
    }

    const ingredientOption = selectableIngredientArray[0];
    const ingredientOptionId = ingredientOption.id;
    pairingsByIngredient[ingredientOptionId] = pairing;
    drawerIngredients.push(ingredientOption);
  });

  return {
    removablePairing,
    ingredients: drawerIngredients,
    pairings: pairingsByIngredient,
  };
}
